import Vue from 'vue';
import TurbolinksAdapter from 'vue-turbolinks';
import Vuex from 'vuex'
import store from './store/index'
import Axios from 'axios'
import vuetify from "./plugins/vuetify"
import VueDateFns from 'vue-date-fns'
import fnsja from 'date-fns/locale/ja'

Vue.use(Vuex)
Vue.use(TurbolinksAdapter)
Vue.use(VueDateFns, 'YYYY-MM-DD', { locale: fnsja })

Axios.defaults.headers['X-CSRF-TOKEN'] = $('meta[name=csrf-token]').attr('content')

let vms = []

let options = {}
let requireContext = require.context('./options', false, /\.js$/)
requireContext.keys().forEach(key => {
  let name = key.split('/').pop().split('.').shift()
  options[name] = requireContext(key).default
})

document.addEventListener('turbolinks:load', () => {
  let templates = document.querySelectorAll('[data-vue]')
  for (let el of templates) {
    let vm = new Vue(
      Object.assign(options[el.dataset.vue], { el, store, vuetify })
    )
    vms.push(vm)
  }
})
